import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import stringHelper from 'utils/stringHelper';



import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';

import { TypeActionCodes } from 'constants.js';
import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';



import TransporteurLinks from './TransporteurLinks';

import QualificationCodeContactTelephoneManquantInnerForm from './QualificationCodeContactTelephoneManquantInnerForm';



const styles = theme => ({
    cardContent: {
        padding: theme.spacing(0, 3, 2, 3)
    },

    cardActions: {
        justifyContent: 'right'
    },


    formControl: {
        margin: 0,
        width: '100%'
    }

});




class QualificationCodeContactTelephoneManquantForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fallbackMode: false
        };
    }


    // Sauvergarde pour le cas expressiste
    handleDone = (event) => {

        const { addAction, cloturer, reclamationId, actionId } = this.props;

        // Action data
        const actionData = {
            code: TypeActionCodes.SouffranceTransporteurMemoReponse,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Texte,
                libelle: "Préciser le contact et le numéro de télephone du contact.",
                position: 0,
                valeurString: "C'est fait."
            }]
        };

        // Cloture
        let cloture = {
            motifResolutionCode: MotifResolutionCodes.CauseTransporteur,
            causePrincipaleCode: CausePrincipaleCodes.ContestationLivraison,
            causePrincipaleDetailId: 0,
            utilisateurFautifId: 0,
            commentaire: '',
            mailAutomatique: ''
        };       

        addAction(reclamationId, actionData, actionId);
        cloturer(reclamationId, cloture);           
    }


           // Sauvergarde
    handleClickSave = (contact, telephone, commentaire) => {

        const { addAction, groupeTransportId, reclamationId, actionId } = this.props;
        

        let sauvegardable = !stringHelper.isNullOrWhitespace(contact) && !stringHelper.isNullOrWhitespace(telephone);

        if (!sauvegardable) {
            return;
        }
        
        // Action data
        const actionData = {
            code: TypeActionCodes.SouffranceTransporteurMemoReponse,
            parentReclamationActionId: actionId,
            details: [{
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Contact',
                    position: 0,
                    valeurString: contact
                },
                {
                    code: ReclamationActionDetailCodes.Resultat,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Téléphone',
                    position: 1,
                    valeurString: telephone
                }]
        };



        if (!stringHelper.isNullOrWhitespace(commentaire)) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: commentaire
            };

            actionData.details.push(detail);
        }

        
        addAction(reclamationId, actionData, actionId, groupeTransportId);

    }


    handleClickFallback = () => {

        this.setState({
            ...this.state,
            fallbackMode: true
        });

    };
    handleClickCancelFallback = () => {

        this.setState({
            ...this.state,
            fallbackMode: false
        });

    };

    render() {
        const { reclamationId, isAdding } = this.props;
        const { fallbackMode } = this.state; 


        const fallbackComponent = <QualificationCodeContactTelephoneManquantInnerForm open isAdding={isAdding} onClickSave={this.handleClickSave} onClickCancelFallback={this.handleClickCancelFallback}/>;

        return (
            <TransporteurLinks
                reclamationId={reclamationId}
                isAdding={isAdding}

                onClickDone={this.handleDone}
                onClickFallback={this.handleClickFallback}

                fallbackComponent={fallbackComponent}
                fallbackMode={fallbackMode}
            />
        );
    }
}
QualificationCodeContactTelephoneManquantForm.propTypes = {
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(QualificationCodeContactTelephoneManquantForm);